import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('access_token'));
  const [selectedProjectId, setSelectedProjectId] = useState(null);

  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({ id: payload.user_id, role: payload.role, email: payload.sub });
      } catch (e) {}
    }
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post('/auth/login', { email, password });
    const newToken = res.data.access_token;
    localStorage.setItem('access_token', newToken);
    setToken(newToken);
    const payload = JSON.parse(atob(newToken.split('.')[1]));
    setUser({ id: payload.user_id, role: payload.role, email: payload.sub });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    setToken(null);
    setUser(null);
    setSelectedProjectId(null);
  };

  const value = {
    user, token, login, logout,
    selectedProjectId, setSelectedProjectId,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
